import { render, staticRenderFns } from "./state-of-residence.vue?vue&type=template&id=4f0a061a&scoped=true&lang=pug&"
import script from "./state-of-residence.vue?vue&type=script&lang=js&"
export * from "./state-of-residence.vue?vue&type=script&lang=js&"
import style0 from "./state-of-residence.vue?vue&type=style&index=0&id=4f0a061a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0a061a",
  null
  
)

export default component.exports